import Navbar from "@/components/marketing/Navbar.jsx";
import Footer from "@/components/marketing/Footer.jsx";
import { Mail, MessageCircle, Wand2, Briefcase, FileText, Users, Sparkles, Phone } from "lucide-react";

const cases = [
  { icon: Mail, t: "Founders & PMs", d: "Capture investor updates, hiring DMs, and team announcements in seconds." },
  { icon: MessageCircle, t: "Sales & Support", d: "Replicate your tone of voice across 100 WhatsApp & email follow-ups daily." },
  { icon: Wand2, t: "AI builders", d: "Brainstorm prompts out loud, get a structured Role/Context/Task prompt back." },
  { icon: Briefcase, t: "Agencies & Freelancers", d: "Convert client calls into tidy briefs and scopes — no manual rewriting." },
  { icon: FileText, t: "Writers & Creators", d: "Spoken ideas become blog outlines, scripts, and social posts." },
  { icon: Users, t: "Operations & HR", d: "Turn standups and 1:1s into clean notes with action items." },
  { icon: Phone, t: "Customer Success", d: "Polished post-call summaries for CRM — no copy-pasting fumbles." },
  { icon: Sparkles, t: "Students & Researchers", d: "Voice journal, study notes, and paper outlines without the wrist pain." },
];

export default function UseCases() {
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <section className="pt-16 pb-12 text-center bg-mesh">
        <div className="text-xs uppercase tracking-widest font-semibold text-brand-purple">Use cases</div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-navy">Built for everyone<br />who types all day.</h1>
      </section>
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {cases.map((c, i) => (
            <div key={i} className="bg-white rounded-2xl border border-brand-borderc p-6 hover:border-brand-purple/40 hover:shadow-soft transition">
              <div className="w-10 h-10 rounded-xl bg-brand-surface flex items-center justify-center text-brand-purple"><c.icon className="w-5 h-5" /></div>
              <h3 className="mt-3 font-semibold text-brand-navy">{c.t}</h3>
              <p className="mt-1 text-sm text-brand-muted">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
